module.exports = __webpack_public_path__ + "static/img/img-tuto03-01.da9a2ffb.png";